var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_4455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 29.3333L22 22M22 22L14.6667 29.3333M22 22V38.5M37.3817 33.715C39.1698 32.7402 40.5823 31.1976 41.3964 29.3308C42.2105 27.464 42.3797 25.3793 41.8774 23.4056C41.375 21.432 40.2297 19.6818 38.6222 18.4313C37.0147 17.1809 35.0366 16.5014 33 16.5H30.69C30.1351 14.3536 29.1008 12.361 27.6649 10.6718C26.229 8.98271 24.4289 7.64107 22.3998 6.74779C20.3708 5.85451 18.1657 5.43284 15.9502 5.51446C13.7347 5.59609 11.5666 6.17889 9.60881 7.21906C7.65101 8.25923 5.95449 9.7297 4.64679 11.5199C3.3391 13.3101 2.45425 15.3735 2.05878 17.5549C1.66332 19.7363 1.76751 21.979 2.36355 24.1143C2.95958 26.2497 4.03193 28.2221 5.49999 29.8833",
    stroke: "#FFFAEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_4455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.9d17e763d6bf22e68a3ee18455724138.svg";
export { ForwardRef as ReactComponent };